export const PAYMENT_GATEWAYS_INDEX_TOUR = {
  id: "payment_gateways_index",
  steps: [
    {
      element: '[data-tour="gateways-create"]',
      popover: {
        title: "Configurar gateway",
        description:
          "Conecte Asaas, Stripe ou dLocal Go para processar as cobranças das assinaturas.",
        side: "bottom",
      },
    },
    {
      element: '[data-tour="gateways-list"]',
      popover: {
        title: "Gateways configurados",
        description: "Veja o status de cada gateway conectado à sua conta.",
        side: "top",
      },
    },
  ],
};
